var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":"","fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","fill-height":""}},[_c('v-card',{staticClass:"trailer-player",attrs:{"flat":"","width":"100%","height":"600px"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }